// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.shared-database-page .details-value.text-value {\n  margin-left: 0;\n}\n.shared-database-page .details-item {\n  flex-direction: column;\n  padding-left: 0;\n}\n.shared-database-page .details-item span {\n  padding-left: 0;\n}\n.shared-database-page .dropdown-readonly {\n  text-align: left;\n  padding-top: 0;\n  padding-bottom: 0;\n}\n.shared-database-page .details-label {\n  padding-bottom: 0;\n}\n", ""]);
// Exports
module.exports = exports;
